/*
 * File: /src/components/BaseWysiwyg.1.vue
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Monday, 30th July 2018 3:21:31 pm
 * Last Modified: Monday, 6th August 2018 3:33:09 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */
<template>
  <div :class="className" class="base-wysiwyg">
    <label>{{ label }}</label>
    <tinymce :id="String(id)" v-model="valueModel" v-on="listeners" :other_options="options" ></tinymce>
    <TypographyInputHint v-if="hint">{{ hint }}</TypographyInputHint>
    <TypographyMeta v-if="meta" v-html="meta"></TypographyMeta>
    <TypographyInputError v-if="hasErrors">{{ errors.first($attrs.name) }}</TypographyInputError>
  </div>
</template>

<script>
  import BaseInput from './BaseInput'
  import tinymce from '@/packages/vue-tinymce-editor/src/components/TinymceVue'
  import { generateUuid } from '@/helpers'
  import { mapActions } from 'vuex'

  export default {
    extends: BaseInput,

    components: {
      tinymce
    },

    data() {
      return {
        id: generateUuid(),
        valueModel: this.value || '',
        options: {
          images_upload_handler: this.uploadHandler,
          branding: false,
          convert_urls: false,
        }
      }
    },

    methods: {
      ...mapActions('shopifyApi', ['REQUEST']),

      uploadHandler(blobInfo, success, failure) {
        this.REQUEST({ 
          endpoint: 'image',
          method: 'POST',
          data: {
            filename: blobInfo.filename(),
            base64: blobInfo.base64()
          },
        }).then((data) => {
          success(data.url)
        }).catch((error) => {
          console.error('Cannot upload image', error)
          failure('Cannot upload image')
        })
      }
    },

    computed: {
      listeners () {
          return {
            input: e => this.$emit('input', this.valueModel),
            editorInit: editor => editor.setContent(this.valueModel),
          }
        }
    }
  }
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';

  .base-wysiwyg {

    // editor:
    .mce-tinymce {
      border-radius: 3px;
      box-shadow: none;
      border-color: #d3dbe2;
    }

    .mce-panel {
      border-color: #d3dbe2;
    }

    .mce-edit-area {
      padding: 0 2px;
    }

    .mce-btn:not(.mce-flow-layout-item) {
      background: linear-gradient(180deg, #fff, #f9fafb);
      border: 1px solid #c4cdd5;
      border-radius: 3px;

      &.mce-first.mce-last {
        border-radius: 3px !important;
      }

      button i {
        color: #000;
      }
    }

    .mce-top-part::before {
      display: none;
    }

    .mce-btn.mce-active {
      background: linear-gradient(to bottom, #f4f6f8, #f4f6f8);
      border-color: #c4cdd5;
      box-shadow: inset 0 1px 1px 0 rgba(99, 115, 129, 0.1), inset 0 1px 4px 0 rgba(99, 115, 129, 0.2);

      button i {
        color: #000;
      }
    }

    .mce-menubar {
      background-color: #fafbfc;
      border: none;
    }

    .mce-flow-layout {
      background-color: #fafbfc;
    }

    .mce-flow-layout-item {
      margin: 5px 0 5px 5px;
    }

    .mce-statusbar.mce-stack-layout-item {
      border: none;

      .mce-path,
      .mce-wordcount {
        display: none;
      }
    }

    .mce-btn-group {
      padding: 0;
      border: none;
      margin-left: 5px;
      margin-bottom: 5px;

      .mce-btn {
        border-radius: 0;
        margin-left: -1px;

        button {
          padding: 5px 10px;
        }

        &:first-of-type {
          border-radius: 3px 0 0 3px;
        }

        &:last-of-type {
          border-radius: 0 3px 3px 0;
        }
      }
    }
  } // modal
  #mce-modal-block {
    background-color: #000;
    opacity: 0.4;
  }

  .mce-window {
    border: 1px solid $color-dusty-gray;
    border-radius: 6px;
    box-shadow: 0 31px 41px 0 rgba(32, 42, 53, .2), 0 2px 16px 0 rgba(32, 42, 54, .08);

    .mce-window-head {
      padding: 20px 30px;
      border-bottom: 1px solid $color-border;

      .mce-title {
        color: $color-text-primary;
        font-size: 20px;
        font-weight: normal;
        line-height: 1.2;
      }

      .mce-close {
        width: 60px;
        height: 55px;
      }

      .mce-close i {
        color: $color-text-primary !important;
        font-size: 19px;
      }
    }

    .mce-btn {
      height: auto !important;
      background: linear-gradient(180deg, #fff, #f9fafb);
      border: 1px solid #c4cdd5;
      border-radius: 3px;

      button {
        padding: 7px 10;
        font-size: 14.6px;
        font-weight: 400;
      }
      &.mce-primary {
        background: linear-gradient(180deg, #6371c7, #5563c1);
        color: #fff;
        border-color: #3f4eae;
        box-shadow: inset 0 1px 0 0 #6774c8, 0 1px 0 0 rgba(22, 29, 37, .05), 0 0 0 0 transparent;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/base/BaseWysiwyg.vue